<template>
  <div style="margin-bottom: 10px">
    <el-card class="box-card">
      <el-form label-width="100px">
        <el-form-item label="花费：">
          <el-input
            style="width: 80px"
            size="mini"
            v-model="data.cost"
          ></el-input>
        </el-form-item>
      </el-form>
    </el-card>
  </div>
</template>

<script>
export default {
  data() {
    return {
      data: {
        cost: "",
      },
    };
  },
  components: {},

  watch: {
    data: {
      async handler() {
        await this.updatedParam();
      },
      deep: true,
    },
  },

  async created() {
    await this.loadConfig();
    if (this.parameter) {
      this.data = JSON.parse(this.parameter);
    }
  },

  props: {
    parameter: "",
  },

  methods: {
    async loadConfig() {},

    async updatedParam() {
      if (typeof this.data.cost == "string") {
        this.data.cost = this.data.cost.trim();
      }

      this.$emit("updated", JSON.stringify(this.data), async () => {
        if (!this.data.cost) {
          return { errMsg: "花费不能为空" };
        }

        if (parseInt(this.data.cost).toString() != String(this.data.cost)) {
          return { errMsg: "花费必须是一个整数" };
        }
        // 另最后的参数中的cost是一个数值类型
        this.data.cost = parseInt(this.data.cost);
        return;
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.link-button {
  padding-left: 5px;
  padding-right: 5px;
  color: rgb(37, 148, 240);

  cursor: pointer;
}

/deep/ .el-table__row td {
  padding: 0px 0;
}

.el-table .cell.el-tooltip {
  white-space: normal;
}
</style>